export default "__VITE_ASSET__BoMRD5HL__"